import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { handleApiError } from "../handleApiError";
import axiosInstance from "../axiosInstance";

const API_URL = "/question";

// ---------------- ADD QUESTION ----------------
export const addQuestion = createAsyncThunk(
  "question/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${API_URL}`, data);
      toast.success("تم إضافة السؤال بنجاح");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- GET ONE ----------------
export const getOneQuestion = createAsyncThunk(
  "question/getOne",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- GET ALL ----------------
export const getQuestions = createAsyncThunk(
  "question/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();

      if (params.page) query.append("page", params.page);
      if (params.limit) query.append("limit", params.limit);
      if (params.search) query.append("search", params.search);

      const response = await axiosInstance.get(
        `${API_URL}?${query.toString()}`,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- UPDATE ----------------
export const updateQuestion = createAsyncThunk(
  "question/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/${id}`, data);
      toast.success("تم تحديث السؤال");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- DELETE ----------------
export const deleteQuestion = createAsyncThunk(
  "question/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}/${id}`);
      toast.success("تم حذف السؤال");
      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- TOGGLE ACTIVE ----------------
export const toggleQuestionActive = createAsyncThunk(
  "question/toggle-active",
  async (id, { rejectWithValue }) => {
    try {
      // console.log("Toggling active status for question ID:", id);
      const response = await axiosInstance.patch(
        `${API_URL}/toggle-active/${id}`,
      );

      toast.success("تم تغيير حالة السؤال");

      return id;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
